/* 3SQM — shared stagger-reveal observer (Telfar-energy fades).
   One IntersectionObserver for the whole page, exposed as window.__sqmReveal
   so any section can register nodes late: window.__sqmReveal.add(el).
   Adds `.is-in` to `.reveal` elements as they enter the viewport.

   JS-off safety: the hiding CSS is gated on `html.js-reveal-ready`,
   which only this file adds — without JS everything stays visible.
   Reduced motion: everything is revealed instantly (CSS also kills the
   transition under prefers-reduced-motion). */
(() => {
  if (window.__sqmReveal) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const showAll = () => {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
  };

  if (!('IntersectionObserver' in window) || reduceMotion.matches) {
    window.__sqmReveal = {
      add: (el) => el.classList.add('is-in'),
    };
    document.documentElement.classList.add('js-reveal-ready');
    showAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px 20% 0px', threshold: 0.01 }
  );

  window.__sqmReveal = {
    observer,
    add: (el) => observer.observe(el),
  };

  document.documentElement.classList.add('js-reveal-ready');
  // Double rAF: the hidden state must PAINT once before .is-in lands,
  // otherwise elements already in the viewport skip the transition entirely.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.querySelectorAll('.reveal:not(.is-in)').forEach((el) => observer.observe(el));
    });
  });

  reduceMotion.addEventListener('change', (event) => {
    if (event.matches) showAll();
  });
})();

/* Theme Editor: re-rendered sections come back with fresh .reveal nodes
   that no one observes — register them so they don't stay invisible. */
document.addEventListener('shopify:section:load', (event) => {
  if (!window.__sqmReveal) return;
  event.target.querySelectorAll('.reveal:not(.is-in)').forEach((el) => {
    window.__sqmReveal.add(el);
  });
});
